import path from "path";
import { isValidDate } from "../functions/is-valid-date";

export class HttpMethod {
    static Get = "GET";
    static Post = "POST";
}

/**
 * HTTP Client utility, used to call node APIs from the client side.
 */
export class HttpClient {
    static _client;
    baseUrl;
    token;

    constructor(baseUrl, token) {
        this.baseUrl = baseUrl;
        this.token = token;
    }

    /**
     * Gets a HTTP client instance with base path set.
     * @param baseUrl The base path.
     * @returns {HttpClient}.
     */
    static api(baseUrl, token) {
        if (!HttpClient._client) {
            HttpClient._client = new HttpClient(baseUrl, token);
        }
        return HttpClient._client;
    }

    /**
     * Performs a HTTP POST request using the provided options parameter.
     * @param options The HTTP options for the request.
     * @returns Promise of type @type {TResponseType}.
     */
    async post(options) {
        return this.request(options, HttpMethod.Post);
    }

    /**
     * Performs a HTTP GET request using the provided options parameter.
     * @param options The HTTP options for the request.
     * @returns Promise of type @type {TResponseType}.
     */
    async get(options) {
        return this.request(options, HttpMethod.Get);
    }

    async request(options, method) {
        try {
            const fetchOptions = await this.getFetchOptions(options, method);
            const response = await fetch(this.getUrl(options.path), fetchOptions);
            return await HttpClient.getResponse(response, options);
        }
        catch (error) {
            return HttpClient.getErrorResponse(error, options);
        }
    }

    async getFetchOptions(requestOptions, method) {

        const fetchOptions = {
            method: method,
            mode: "cors",
            cache: "no-cache",
            referrerPolicy: "no-referrer"
        };

        var headers = {};

        if (requestOptions.body) {
            headers["Content-Type"] = "application/json";
            const copy = {
                ...requestOptions.body
            };
            processJsonValues(copy);
            fetchOptions.body = JSON.stringify(copy);
        }
        
        if (this.token) {
            headers["Authorization"] = "Bearer " + this.token;
        }

        fetchOptions.headers = headers;

        return fetchOptions;
    }

    getUrl(urlPath) {
        const isRelative = !(this.baseUrl.startsWith("http://") || this.baseUrl.startsWith("https://"));

        let url;
        if (isRelative) {
            url = this.baseUrl || "/";
            url = path.join(url, urlPath);
        }
        else {
            const scheme = this.baseUrl.startsWith("https://") ? "https://" : "http://";
            const originWithoutScheme = this.baseUrl.replace(scheme, "");
            url = scheme + path.join(originWithoutScheme, urlPath);
        }

        return url;
    }

    static async getResponse(responseIn, options) {
        const responseOut = {
            statusCode: responseIn.status,
            success: responseIn.status >= 200 && responseIn.status <= 300
        };

        if (responseOut.success && responseOut.statusCode != 204) {
            responseOut.result = await responseIn.json();
        }

        if (responseOut.statusCode == 422) {
            responseOut.validationResult = await responseIn.json();
            console.warn(responseOut.validationResult);
        }

        if (responseOut.statusCode == 401 && options.authRedirectPath) {
            window.location.href = options.authRedirectPath;
        }
        
        return responseOut;
    }

    static async getErrorResponse(error, request) {
       return {
            statusCode: -1,
            success: false
        };
    }
}

const toDateString = input => input.getFullYear() + 
    "-" +
    (input.getMonth()+1).toString().padStart(2, 0) +
    "-" +
    input.getDate().toString().padStart(2, 0);
    
const processJsonValues = obj => {    
    for (const o in obj) {
        if (obj.hasOwnProperty(o)) {
            let subject = obj[o];
            if (isValidDate(subject)) {                 
                var s = toDateString(subject);
                obj[o] = s;
            }
            else if (typeof subject === 'object') {
                processJsonValues(subject);
            }
        }
    }             
};